// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e0f287c4","639":"bb5a4136"}[chunkId] + ".chunk.js";
};